import React, { Fragment, useCallback } from 'react';
import { IoTrash } from 'react-icons/io5';
import Input from '~/components/Input';
import InputDate from '~/components/InputDate';
import InputMask from '~/components/InputMask';
import { IContract } from '..';

interface IContractsProps {
  contracts: IContract[];
  onChange: (contracts: IContract[]) => void;
}

const Contracts: React.FC<IContractsProps> = ({ contracts, onChange }) => {
  const handleChangeLoanAmount = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
      const newContracts = contracts.map((contract, i) => {
        if (i === index) {
          return {
            ...contract,
            loanAmount: e.target.value,
          };
        }
        return contract;
      });
      onChange(newContracts);
    },
    [contracts, onChange]
  );

  const handleChangeContractDate = useCallback(
    (date, index: number) => {
      const newContracts = contracts.map((contract, i) => {
        if (i === index) {
          return {
            ...contract,
            contractDate: date,
          };
        }
        return contract;
      });
      onChange(newContracts);
    },
    [contracts, onChange]
  );

  const handleChangeReturnPercentage = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
      const newContracts = contracts.map((contract, i) => {
        if (i === index) {
          return {
            ...contract,
            returnPercentage: e.target.value,
          };
        }
        return contract;
      });
      onChange(newContracts);
    },
    [contracts, onChange]
  );

  const handleChangePaymentAmount = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
      const newContracts = contracts.map((contract, i) => {
        if (i === index) {
          return {
            ...contract,
            paymentAmount: e.target.value,
          };
        }
        return contract;
      });
      onChange(newContracts);
    },
    [contracts, onChange]
  );

  const handleChangePaymentDate = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
      const newContracts = contracts.map((contract, i) => {
        if (i === index) {
          return {
            ...contract,
            paymentDate: e.target.value,
          };
        }
        return contract;
      });
      onChange(newContracts);
    },
    [contracts, onChange]
  );

  const handleChangeMaturitytDate = useCallback(
    (date, index: number) => {
      const newContracts = contracts.map((contract, i) => {
        if (i === index) {
          return {
            ...contract,
            maturityDate: date,
          };
        }
        return contract;
      });
      onChange(newContracts);
    },
    [contracts, onChange]
  );

  const handleDeleteContract = useCallback(
    (index: number) => {
      const newContracts = contracts.filter((_, i) => i !== index);
      onChange(newContracts);
    },
    [contracts, onChange]
  );
  return (
    <>
      {contracts.map((contract, index) => (
        <Fragment key={contract.id}>
          <div className="col-12">
            <hr className="my-4" />
            <div className="text-end">
              {contracts.length > 1 && (
                <button
                  type="button"
                  onClick={() => handleDeleteContract(index)}
                  className="border-0 bg-transparent"
                >
                  <IoTrash color="#f00" size={20} />
                </button>
              )}
            </div>
            <div className="row">
              <div className="col-lg-4 mb-4">
                <h3>Loan Amount</h3>
                <InputMask
                  name={`loanAmount_${contract.id}`}
                  className="bd-input"
                  kind="money"
                  options={{ unit: '$', separator: '.', delimiter: ',' }}
                  value={contract.loanAmount}
                  onChange={(e) => handleChangeLoanAmount(e, index)}
                />
              </div>
              <div className="col-lg-4 mb-4">
                <h3>Contract Date</h3>
                <InputDate
                  name={`contractDate_${contract.id}`}
                  selected={contract.contractDate}
                  onChange={(e) => handleChangeContractDate(e, index)}
                  className="bg-transparent"
                  dateFormat="MM/dd/yyyy"
                />
              </div>
              <div className="col-lg-4 mb-4">
                <h3>Return %</h3>
                <Input
                  name={`returnPercentage_${contract.id}`}
                  type="number"
                  className="bd-input"
                  value={contract.returnPercentage}
                  onChange={(e) => handleChangeReturnPercentage(e, index)}
                />
              </div>
              <div className="col-lg-4 mb-4">
                <h3>Payment Amount</h3>
                <InputMask
                  name={`paymentAmount_${contract.id}`}
                  className="bd-input"
                  kind="money"
                  options={{ unit: '$', separator: '.', delimiter: ',' }}
                  value={contract.paymentAmount}
                  onChange={(e) => handleChangePaymentAmount(e, index)}
                />
              </div>
              <div className="col-lg-4 mb-4">
                <h3>Payment Date</h3>
                <Input
                  name={`paymentDate_${contract.id}`}
                  type="text"
                  className="bd-input"
                  value={contract.paymentDate}
                  onChange={(e) => handleChangePaymentDate(e, index)}
                />
              </div>
              <div className="col-lg-4 mb-4">
                <h3>Maturity Date</h3>
                <InputDate
                  name={`maturityDate_${contract.id}`}
                  selected={contract.maturityDate}
                  onChange={(e) => handleChangeMaturitytDate(e, index)}
                  className="bg-transparent"
                  dateFormat="MM/dd/yyyy"
                />
              </div>
            </div>
          </div>
        </Fragment>
      ))}
    </>
  );
};

export default Contracts;
